/**
 * Формирует тело/параметры для POST /api/v2/executors/search.
 * Фильтрацию списка делает только backend.
 */

const PLATE_LATIN = 'ABEKMHOPCTYX';
const PLATE_CYRILLIC = 'АВЕКМНОРСТУХ';

export function normalizePlateNumber(value) {
  if (value == null) return '';
  const cleaned = String(value)
    .toUpperCase()
    .replace(/[\s\u00a0-]/g, '');
  if (!cleaned) return '';

  return cleaned
    .split('')
    .map((char) => {
      const index = PLATE_LATIN.indexOf(char);
      return index >= 0 ? PLATE_CYRILLIC[index] : char;
    })
    .join('');
}

export function buildExecutorSearchPayload({
  companyId = null,
  companyQuery = '',
  driver = '',
  car = '',
  trailer = '',
  availability = '',
} = {}) {
  const payload = {};
  const query = String(companyQuery || '').trim();

  if (companyId) {
    payload.company = { id: companyId };
  } else if (query) {
    payload.company = /^\d+$/.test(query)
      ? { inn: query }
      : { name: query };
  }

  const driverName = String(driver || '').trim();
  if (driverName) {
    payload.driver = { first_name: driverName };
  }

  const carNumber = normalizePlateNumber(car);
  if (carNumber) {
    payload.car = { number: carNumber };
  }

  const trailerNumber = normalizePlateNumber(trailer);
  if (trailerNumber) {
    payload.trailer = { number: trailerNumber };
  }

  if (availability === 'available' || availability === 'unavailable') {
    payload.availability = availability;
    payload.is_success = availability === 'available';
  }

  return payload;
}

export function hasExecutorSearchFilters(payload) {
  return Boolean(payload && Object.keys(payload).length > 0);
}

export function getAvailabilityMode(form = {}) {
  if (form.availability === 'available' || form.availability === 'unavailable') {
    return form.availability;
  }
  if (form.is_success === true) return 'available';
  if (form.is_success === false) return 'unavailable';
  return '';
}

/** Только для отображения badge в таблице, не для фильтрации списка. */
export function isExecutorAvailable(row) {
  return row?.is_success === true;
}

export function buildExecutorSearchParams(form, page, perPage) {
  const params = { page, per_page: perPage };
  const mode = getAvailabilityMode(form);
  if (mode) {
    params.availability = mode;
  }
  return params;
}

export function parseExecutorSearchPayload(payload = {}) {
  const filters = {
    companyId: payload.company?.id || null,
    companyQuery: '',
    driver: payload.driver?.first_name || '',
    car: payload.car?.number || '',
    trailer: payload.trailer?.number || '',
    availability: getAvailabilityMode(payload),
  };

  if (payload.company?.inn) {
    filters.companyQuery = payload.company.inn;
  } else if (payload.company?.name) {
    filters.companyQuery = payload.company.name;
  }

  return filters;
}
